const statusActionModalFilter = {
  progress: 'Em Andamento',
  overdue: 'Vencido',
  completed: 'Concluído',
  canceled: 'Cancelado'
};

export default statusActionModalFilter;
